module.exports = __webpack_public_path__ + "img/invite_redbox.fe719953.png";